import { useState as c, useEffect as i, useRef as o } from "react";
const b = (e) => {
  const [n, s] = c(!1);
  return i(() => {
    const t = new IntersectionObserver(([r]) => s(r.isIntersecting));
    return e.current && t.observe(e.current), () => {
      t.disconnect();
    };
  }, [e]), n;
}, I = (e) => {
  const [, n] = c(!1), s = o(!1);
  return i(() => {
    const t = new IntersectionObserver(([r]) => {
      r.isIntersecting && !s.current && (s.current = !0, n(!0));
    });
    return e.current && t.observe(e.current), () => {
      t.disconnect();
    };
  }, [e]), s.current;
};
export {
  b as useIsVisible,
  I as useIsVisibleOnce
};
